__turbopack_context__.v({
  "backdrop": "_9_w_sq_backdrop",
  "collapsable": "_9_w_sq_collapsable",
  "container": "_9_w_sq_container",
  "description": "_9_w_sq_description",
  "hashtags": "_9_w_sq_hashtags",
  "meta": "_9_w_sq_meta",
  "open": "_9_w_sq_open",
  "slideInAnimation": "_9_w_sq_slideInAnimation",
  "stats": "_9_w_sq_stats",
  "title": "_9_w_sq_title",
});
